<smart-query-builder id="queryBuilder"></smart-query-builder>